module.exports = __webpack_public_path__ + "poster8.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/auto-slider/assets/poster8.png
// module id = 1138
// module chunks = 10